export default __webpack_public_path__ + "static/InStride_Health_Horiz_Color_RGB-58530a36d9d1220cba3bdfcc730f5f33.png";